import type { Viewport } from '../hex/camera2d';
import type { MapModel } from '../map/mapModel';
import type { HexMapState } from './renderer';
import { OverlayRenderer } from '../../ui/overlay/OverlayRenderer';
import { CanvasPainter } from '../../ui/overlay/rendering/CanvasPainter';
import { isMobileViewport } from './modalLayout';

export function drawOverlay(
    ctx: CanvasRenderingContext2D,
    model: MapModel,
    state: HexMapState,
    viewport: Viewport,
    zoom: number,
): void {
    ctx.save();
    if (isMobileViewport(viewport) && state.modals.length > 0) {
        ctx.restore();
        return;
    }
    const painter = new CanvasPainter(ctx);
    const renderer = new OverlayRenderer(painter, state.overlayAssets.icons);
    state.actionBarActions = renderer.render({ model, state, viewport, zoom });
    ctx.restore();
}
